<template>
  <div
    class="position-sticky fixed-top bg-black text-white slim-navbar d-flex align-items-center"
  >
    <d-container fluid class="d-flex justify-content-between py-2">
      <d-button theme="clear" class="text-white px-0">Oddular Commerce <span v-if="dev">[dev]</span></d-button>
      <div>
        <d-dropdown
          :text="!!profile ? profile.username : ''"
          theme="clear"
          toggleId="profile-toggle-btn"
          size="sm"
          right
        >
          <!-- <d-dropdown-item to="profile" class="cursor-pointer">Profile</d-dropdown-item> -->
          <!-- <d-dropdown-item to="auth/logout" class="cursor-pointer">Logout</d-dropdown-item> -->
          <d-link to="auth/logout" class="dropdown-item">Logout</d-link>
        </d-dropdown>
      </div>
    </d-container>
  </div>
</template>

<script>
import {__DEV__} from '@/helpers';

export default {
  data() {
    return {
      dev: __DEV__
    }
  },
  methods: {
    logout() {
        this.$store.dispatch("auth/logout").then(() => {
          this.$router.push("/auth/signin");
      });
    },
    editProfile() {

    }
  },
  computed: {
    profile() {
      return this.$store.state.profile.profile;
    }
  }
};
</script>

<style lang="scss">
.slim-navbar {
  height: 2rem;
}

#profile-toggle-btn {
  color: white !important;
  padding: 0.25rem 0;
}
</style>
